import { theme } from "../App";

export const appGreyOutline = "#F9F9FA";
export const appGrey = "#444444";
export const appBlack = "#252525";
export const appWhite = "#F3F3F3";
export const appRed = "#F54F64";
export const appRedLight = "#FF5555";
export const appGreen = "#0A915A";

export const lightestBlue = "#358DE0"; //#2EAAFA

export const appBgColor = "#FBFBFB"; //#E8ECEF

export const errorRed = appRed;

export const placeholderGrey = "#8A8787";
export const navbarBlue = "#0265F4";
export const subTitleBlue = "#0256CF";
export const appDarkBlue = "#001949";
export const textGrey = "#73757A";
export const dividerGrey = "#D9D9D9";

export const blueGradient = `linear-gradient(90deg, ${navbarBlue} 0%, ${lightestBlue} 100%)`;

export const baseShadow3 = "1px 2px 5px 0px rgba(115,117,122,0.3)";
export const baseShadow36 = "1px 2px 6px 0px rgba(115,117,122,0.3)";

export const baseShadow2 = "1px 2px 5px 0px rgba(115,117,122,0.2)";
export const baseShadow5 = "1px 2px 5px 0px rgba(115,117,122,0.5)";
export const baseShadow8 = "1px 2px 5px 0px rgba(115,117,122,0.8)";

export const baseBorder = "1px solid #D9D9D9";
export const blueBorder = `2px solid ${navbarBlue}`;
export const errorBorder = `2px solid ${errorRed}`;

export const borderRadius = "10px";

export const footerColor = "#021433";

export const highlightColor = "#F3F8FF";
export const appYellow = "#FBC42C";

export const zindex = {
    guideOverlay: 9998,
    menuOverlay: 9999,
    navbar: 10000,
    overlay: 10001,
    maxOverlay: 10020,
};

export const articleTitleFont = {
    fontSize: { xs: "21px", sm: "23px" },
    lineHeight: { xs: "29px", sm: "31px" },
    mb: "15px",
};

export const SCREEN_SIZE = 24;

export const FOOTER_HEIGHT = 160; // px

export const tableScrollbarBottom = {
    borderBottomLeftRadius: { xs: "6px", sm: "12px" },
    borderBottomRightRadius: { xs: "6px", sm: "12px" },
    "&::-webkit-scrollbar": {
        display: { xs: "block", sm: "none" },
        height: "6px",
    },
    "&::-webkit-scrollbar-track": {
        display: { xs: "block", sm: "none" },
        boxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
        webkitBoxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
    },
    "&::-webkit-scrollbar-thumb": {
        display: { xs: "block", sm: "none" },
        backgroundColor: "rgba(0,0,0,0.3)",
        outline: "none",
        borderRadius: "16px",
        borderTopLeftRadius: { xs: "0px", sm: "12px" },
        borderTopRightRadius: { xs: "0px", sm: "12px" },
    },
};

const coreThemeFile = () => {
    return {
        palette: {
            primary: {
                main: `${navbarBlue}`,
                light: `${lightestBlue}`,
                dark: `${navbarBlue}`,
                contrastText: "#fff",
            },
            secondary: {
                light: "#ff6333",
                main: "#ff3d00",
                dark: "#b22a00",
                contrastText: "#fff",
            },
            error: {
                light: appRed,
                main: appRed,
                dark: appRed,
            },
        },
        components: {
            MuiTypography: {
                defaultProps: {
                    variantMapping: {
                        big: 'h2',
                        title: 'h1',
                        blue: 'p',
                        button: 'p'
                    },
                },
                styleOverrides: {
                    root: ({ ownerState }) => ({
                        fontFamily: 'inter',
                        fontSize: "16px",
                        color: '#1A1C1E',
                        textTransform: "none",
                        ...(ownerState.variant === "big" && {
                            fontSize: "32px",
                            fontWeight: 700,
                            lineHeight: "41px",
                            [theme.breakpoints.only('xs')]: {
                                fontSize: '28px',
                                lineHeight: "37px",
                            },
                        }),
                        ...(ownerState.variant === "medium" && {
                            fontSize: "25px",
                            fontWeight: 700,
                            lineHeight: "32px",
                            letterSpacing: '-0.2px',
                        }),
                        ...(ownerState.variant === "title" && {
                            fontSize: "40px",
                            fontWeight: 700,
                            lineHeight: "52px",
                            [theme.breakpoints.only('xs')]: {
                                fontSize: '34px',
                                lineHeight: "46px",
                            },
                        }),
                        ...(ownerState.variant === "blue" && {
                            fontSize: "19px",
                            fontWeight: 700,
                            lineHeight: "24px",
                            color: navbarBlue,
                        }),
                        ...(ownerState.variant === "button" && {
                            fontSize: "14px",
                            lineHeight: "20px",
                            color: 'white',
                            fontWeight: 'bold'
                        }),

                        ...(ownerState.variant === "help" && {
                            fontSize: "20px",
                            fontWeight: 700,
                            lineHeight: "26px",
                        }),

                    }),
                },
            },
            MuiButtonBase: {
                defaultProps: {
                    disableRipple: true,
                    //disableFocusRipple: true,
                },
            },
            MuiButton: {
                styleOverrides: {
                    root: ({ ownerState }) => ({}),
                },
            },
            MuiGrid: {
                styleOverrides: {
                    root: ({ ownerState }) => ({
                        padding: 0,
                    }),
                },
            },
        },
        typography: {
            useNextVariants: true,
            fontFamily: '"inter", "Roboto"',
        },
    };
};
export default coreThemeFile;
